import { type ReactNode } from 'react';
import {
  BODY,
  Bullet,
  Card,
  Section,
  Stat,
  Subsection,
} from './rules-typography';
import { PaceTable } from './rules-1-pace-table';

export function HowYouEarn(): ReactNode {
  return (
    <Section title="Cómo ganas dinero">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          Se te paga por creador. Tu contador diario empieza en cero cada día.
        </Bullet>
        <Bullet>
          Cuantos más creadores encuentres, más ganas (por tramos).
        </Bullet>
        <Bullet>El dinero sale de un bote total de $40.000.</Bullet>
      </ul>
      <p className={BODY}>
        Cuanto más juegues y mejores resultados tengas, más dinero te llevas.
      </p>
    </Section>
  );
}

function ScenarioBreakdown(): ReactNode {
  return (
    <Subsection title="Escenario competitivo">
      <Card>
        <ul className={`${BODY} space-y-1.5`}>
          <Bullet>
            Base: 99 × $0,55 × 30 ={' '}
            <strong className="text-text-primary">$1.633,50</strong>
          </Bullet>
          <Bullet>
            Bonuses estimados:{' '}
            <strong className="text-text-primary">$1.266</strong>
          </Bullet>
          <Bullet>
            Total potencial:{' '}
            <strong className="text-brand-red">$2.899,50</strong>
          </Bullet>
        </ul>
      </Card>
    </Subsection>
  );
}

function GoalTiers(): ReactNode {
  return (
    <Card>
      <div className="grid grid-cols-3 gap-base text-center">
        <Stat value="33/día" label="sobrevives" />
        <Stat value="66/día" label="compites" />
        <Stat value="99/día" label="ganas en serio" />
      </div>
    </Card>
  );
}

export function Earn2500(): ReactNode {
  return (
    <Section title="Cómo ganar $2.500 en 30 días">
      <p className={BODY}>
        Aquí no hay humo, hay números. Para llegar a +$2.500 con bonuses máximos
        necesitas{' '}
        <strong className="text-text-primary">99 creadores al día</strong>.
      </p>
      <ScenarioBreakdown />
      <PaceTable />
      <GoalTiers />
      <p className={BODY}>
        No todo el mundo va a llegar a 99. Pero si lo haces,{' '}
        <strong className="text-brand-red">ganas asegurado</strong>.
      </p>
    </Section>
  );
}
